import 'svelte/internal/disclose-version';
import 'svelte/internal/flags/legacy';
import * as $ from 'svelte/internal/client';
import { layerStore } from "@/stores/layers.svelte";

var root_1 = $.from_html(`<label class="toggle-row svelte-1fgr5p9f79vwf"><input type="checkbox" class="svelte-1fgr5p9f79vwf"/> <span class="toggle-label svelte-1fgr5p9f79vwf"> </span></label>`);
var root = $.from_html(`<div class="layer-toggles svelte-1fgr5p9f79vwf"><label class="section-label svelte-1fgr5p9f79vwf">Layers</label> <div class="toggles svelte-1fgr5p9f79vwf"></div></div>`);

function LayerToggles($$anchor, $$props) {
	$.push($$props, false);
	$.init();

	var div = root();
	var div_1 = $.sibling($.child(div), 2);

	$.each(div_1, 5, () => layerStore.layers, $.index, ($$anchor, layer) => {
		var label = root_1();
		var input = $.child(label);

		$.remove_input_defaults(input);

		var span = $.sibling(input, 2);
		var text = $.child(span, true);

		$.reset(span);
		$.reset(label);

		$.template_effect(() => {
			$.set_checked(input, $.get(layer).active);
			$.set_text(text, $.get(layer).label);
		});

		$.delegated('change', input, () => layerStore.toggle($.get(layer).id));
		$.append($$anchor, label);
	});

	$.reset(div_1);
	$.reset(div);
	$.append($$anchor, div);
	$.pop();
}

if (import.meta.hot) {
	LayerToggles = $.hmr(LayerToggles);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-1fgr5p9f79vwf');
		LayerToggles[$.HMR].update(module.default);
	});
}

export default LayerToggles;

$.delegate(['change']);
import "bun-svelte:LayerToggles.svelte-2bau9whultywi-style.css";